import { FC } from 'react';

import CheckboxGroup from '@/components/ui/CheckboxGroup';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import { useStepper } from '@/features/v2/lib/stepper';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const REPAIR_DOCUMENTS_PROVIDED_TO_IC = {
  INVOICES: 'provided_to_ic_invoices',
  RECEIPTS: 'provided_to_ic_receipts',
  OTHER_DOCUMENTS: 'provided_to_ic_other_documents',
  ANY: 'any',
} as const;

export const REPAIR_DOCUMENTS_PROVIDED_TO_IC_NAME =
  'repair_documents_provided_to_ic';
export const REPAIR_DOCUMENTS_PROVIDED_TO_IC_NAME_COMPLEMENTARY =
  'repair_documents_provided_to_ic_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const CheckboxGroupRepairDocumentsProvided: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ?? isComplementary
      ? REPAIR_DOCUMENTS_PROVIDED_TO_IC_NAME_COMPLEMENTARY
      : REPAIR_DOCUMENTS_PROVIDED_TO_IC_NAME;

  const { innerStep } = useStepper();
  const isRequired = innerStep === 4;

  return (
    <div id={name} className="overflow-initial scroll-mt-10">
      <FormField
        control={control}
        name={fieldName}
        rules={{
          required: {
            value: isRequired,
            message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
          },
        }}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {i18n.t(
                'Czy przekazywano do ubezpieczalni likwidującej szkodę faktury, rachunki lub inne dokumenty potwierdzające naprawę pojazdu, zakup części?'
              )}
            </FormLabel>
            <FormControl>
              <CheckboxGroup
                field={field}
                options={[
                  {
                    value: REPAIR_DOCUMENTS_PROVIDED_TO_IC.INVOICES,
                    label: i18n.t('Faktury'),
                  },
                  {
                    value: REPAIR_DOCUMENTS_PROVIDED_TO_IC.RECEIPTS,
                    label: i18n.t('Rachunki'),
                  },
                  {
                    value: REPAIR_DOCUMENTS_PROVIDED_TO_IC.OTHER_DOCUMENTS,
                    label: i18n.t('Inne dokumenty'),
                  },
                  {
                    value: REPAIR_DOCUMENTS_PROVIDED_TO_IC.ANY,
                    label: i18n.t('Nie'),
                    willResetRest: true,
                  },
                ]}
                data-testid="checkbox-group-repair-documents-provided"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
